import axiosInstance from '@/api/axiosInstance';
import type { ContentBlock, CourseModule } from '@/api/createCourse';

export interface EditCoursePayload {
  title?: string;
  tagline?: string;
  description?: string;
  difficulty_level?: 'beginner' | 'intermediate' | 'advanced';
  estimated_hours?: number;
  thumbnail_path?: string;
  hero_banner_path?: string;
  modules?: CourseModule[];
  skillIds?: number[];
  categoryIds?: number[];
  tradeIds?: number[];
  addOnProducts?: Array<{
    id: string;
    availabilityStatus: 'not_available' | 'available' | 'included';
    price: number;
    configValues?: Record<string, any>;
  }>;
}

export interface UpdatedCourse {
  id: number;
  title: string;
  tagline: string | null;
  description: string;
  difficulty_level: 'beginner' | 'intermediate' | 'advanced';
  estimated_hours: string | null;
  thumbnail_path: string | null;
  hero_banner_path: string | null;
  archived: boolean;
  created_at: string;
  updated_at: string;
  skills: Array<{
    id: number;
    title: string;
  }>;
  categories: Array<{
    id: number;
    name: string;
  }>;
  modules: Array<{
    id: number;
    title: string;
    description: string;
    order_number: number;
    content_blocks: Array<{
      id: number;
      type: string;
      content: string;
      order_number: number;
      metadata: Record<string, any> | null;
    }>;
  }>;
}

/**
 * Update an existing course
 * PUT /api/learning-center/courses/:id
 * Requires ROLE_LEARNING_ADMIN or ROLE_SUPER_ADMIN
 * Uses last-write-wins strategy
 */
export const editCourse = async (id: number, payload: EditCoursePayload): Promise<UpdatedCourse> => {
  const response = await axiosInstance.put<UpdatedCourse>(
    `/api/learning-center/courses/${id}`,
    payload
  );

  return response.data;
};